// Phase 25 iter-5d — roles client (multi-role per Phase 12 ADR-014).
//
// Endpoints xa existentes no backend (backend/src/routes/v1/users.ts):
//   GET    /api/v1/users/me/roles
//   POST   /api/v1/users/me/roles
//   PATCH  /api/v1/users/me/roles/primary
//   DELETE /api/v1/users/me/roles/:role

import {
  API_VERSION_PREFIX,
  type AddRoleRequest,
  type RolesResponse,
  type UserRole,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function listMyRoles(): Promise<RolesResponse> {
  const { data } = await apiClient.get<RolesResponse>(`${API_VERSION_PREFIX}/users/me/roles`);
  return data;
}

export async function addMyRole(input: AddRoleRequest): Promise<RolesResponse> {
  const { data } = await apiClient.post<RolesResponse>(
    `${API_VERSION_PREFIX}/users/me/roles`,
    input,
  );
  return data;
}

export async function setMyPrimaryRole(role: UserRole): Promise<RolesResponse> {
  const { data } = await apiClient.patch<RolesResponse>(
    `${API_VERSION_PREFIX}/users/me/roles/primary`,
    { role },
  );
  return data;
}

export async function removeMyRole(role: UserRole): Promise<RolesResponse> {
  const { data } = await apiClient.delete<RolesResponse>(
    `${API_VERSION_PREFIX}/users/me/roles/${role}`,
  );
  return data;
}
